(() => {
  function init() {
    if (!document.body.classList.contains('ze-claude-pdp')) return;
    const strings = JSON.parse(document.getElementById('ZePurchaseStrings')?.textContent || '{}');
    document.querySelectorAll('.pdp2-buy,.elite2-buy,.c2hero-buy').forEach(panel => {
      if (panel.classList.contains('ze-purchase-ready')) return;
      const quantity = panel.querySelector('zentein-quantity');
      const fieldset = quantity?.closest('fieldset');
      const productForm = panel.querySelector('product-form');
      const nativeCopy = productForm?.querySelector('[data-pdp2-button-label],[data-elite2-atc-copy],[data-elite2-button-label],[data-c2hero-atc-copy]');
      const sourcePrice = panel.querySelector('.pdp2-price,.elite2-price,.c2hero-price');
      if (!fieldset || !productForm || !sourcePrice) return;
      panel.classList.add('ze-purchase-ready');
      const price = document.createElement('div'); price.className='ze-purchase-price';
      const priceLine = document.createElement('div');priceLine.className='ze-purchase-price-line';
      const original = document.createElement('s');original.className='ze-purchase-original';original.hidden=true;
      const amount = document.createElement('strong');
      const detail = document.createElement('p');
      const detailLead = document.createTextNode('');
      const originalUnit = document.createElement('s');originalUnit.className='ze-purchase-original-unit';originalUnit.hidden=true;
      const unitPrice = document.createElement('span');unitPrice.className='ze-purchase-unit';
      priceLine.append(original,amount);detail.append(detailLead,originalUnit,unitPrice);price.append(priceLine,detail);
      price.setAttribute('aria-live','polite');price.setAttribute('aria-atomic','true');
      const oneTimeAmount = panel.querySelector('[data-c2hero-plan][value=""]')?.closest('label')?.querySelector(':scope > b');
      const oneTimeOriginal = document.createElement('s'),oneTimeCurrent = document.createElement('span');
      if(oneTimeAmount)oneTimeAmount.replaceChildren(oneTimeOriginal,oneTimeCurrent);sourcePrice.before(price);sourcePrice.classList.add('ze-purchase-source-price');
      const block = document.createElement('div');block.className='ze-purchase-actions';fieldset.before(block);block.append(fieldset,productForm);
      const tiers = quantity.querySelector('[data-zq-tiers]');
      const note = quantity.querySelector('[data-zq-next]');
      const noteRow = document.createElement('div');noteRow.className='ze-purchase-saving';
      const title = tiers?.querySelector('strong');if(title)noteRow.append(title);if(note)noteRow.append(note);quantity.prepend(noteRow);
      quantity.querySelectorAll('[data-zq-tier]').forEach((node,i)=>{node.textContent='';const bold=document.createElement('b'),small=document.createElement('small');bold.textContent=['5%','10%','15%'][i];small.textContent=['2','3–4','5+'][i];node.append(bold,small);});
      const copy = nativeCopy || productForm.querySelector('button[name="add"]>span:not(.loading__spinner)');
      const displayCopy = document.createElement('span');displayCopy.className='ze-purchase-button-copy';displayCopy.setAttribute('aria-hidden','true');
      if(copy){copy.classList.add('ze-purchase-native-copy');copy.after(displayCopy);}
      panel.querySelectorAll('.c2hero-assurances>span,.elite2-assurances>span,.pdp2-confidence>span').forEach(item=>{const first=item.firstChild;if(first?.nodeType===3)first.textContent=first.textContent.replace(/^\s*✓\s*/, '');});
      const format = new Intl.NumberFormat(document.documentElement.lang || 'en-CA',{style:'currency',currency:quantity.dataset.currency,currencyDisplay:'narrowSymbol'});
      const money = cents=>format.format(cents/100);
      const render = () => {
        const plan = panel.querySelector('[data-c2hero-plan]:checked');
        const subscription = Boolean(plan?.value);
        const base = Number(quantity.base || quantity.dataset.basePrice);
        const count = Number(quantity.quantity) || Number(quantity.querySelector('[data-zq-input]')?.value) || 1;
        const rate = typeof quantity.rate === 'function' && quantity.rules ? quantity.rate() : 0;
        const quote = window.ZenteinCartRules?.quantityPrice(base,count,rate);
        const oneTime = quote ? Math.round(quote.total/count) : base;
        const current = subscription ? Number(plan.dataset.planPrice) : oneTime;
        const reduced = current < base;
        const pieces = Number(quantity.dataset.pieces)||1;
        amount.textContent=money(current);
        original.textContent=money(base);original.hidden=!reduced;
        original.setAttribute('aria-label',`${strings.regular}: ${money(base)}`);
        amount.setAttribute('aria-label',`${reduced?strings.sale:strings.regular}: ${money(current)}`);
        price.classList.toggle('is-reduced',reduced);
        if(oneTimeAmount){
          oneTimeOriginal.hidden=oneTime>=base;oneTimeOriginal.textContent=money(base);
          oneTimeOriginal.setAttribute('aria-label',`${strings.regular}: ${money(base)}`);
          oneTimeCurrent.textContent=money(oneTime);
          oneTimeCurrent.setAttribute('aria-label',`${oneTime<base?strings.sale:strings.regular}: ${money(oneTime)}`);
          oneTimeAmount.classList.toggle('is-reduced',oneTime<base);
        }
        const variety = Boolean(panel.closest('.elite2--variety'));
        const family = panel.classList.contains('c2hero-buy')?'servings':variety?'pieces':panel.classList.contains('elite2-buy')?'squares':'bars';
        const per = panel.classList.contains('c2hero-buy')?'serving':variety?'piece':panel.classList.contains('elite2-buy')?'square':'bar';
        detailLead.textContent=`${quantity.dataset.currency} · ${pieces} ${family}${panel.classList.contains('c2hero-buy') ? ' per pouch' : ' per box'} · `;
        const perCost = subscription ? Math.round(current/pieces) : quote ? Math.round(quote.total/(count*pieces)) : Math.round(base/pieces);
        originalUnit.textContent=`${money(Math.round(base/pieces))}/${per}`;
        originalUnit.hidden=!reduced;
        originalUnit.setAttribute('aria-label',`${strings.regular}: ${originalUnit.textContent}`);
        unitPrice.textContent=`${money(perCost)}/${per}`;
        unitPrice.setAttribute('aria-label',`${reduced?strings.sale:strings.regular}: ${unitPrice.textContent}`);
        block.classList.toggle('ze-purchase-actions--subscription',subscription);
        noteRow.hidden=subscription || tiers?.hidden;
        const source=copy?.textContent.trim() || '';
        const match=source.match(/(?:CA\$|US\$|\$|€|£)[\d,.]+/g);
        if(copy)displayCopy.textContent=match?.length?`${subscription?strings.subscribe:strings.add} · ${match[match.length-1]}`:source;
      };
      const observer = new MutationObserver(render);
      if(copy)observer.observe(copy,{childList:true,subtree:true,characterData:true});
      if(sourcePrice)observer.observe(sourcePrice,{childList:true,subtree:true,characterData:true});
      if(tiers)observer.observe(tiers,{attributes:true,attributeFilter:['hidden']});
      panel.addEventListener('change',()=>queueMicrotask(render));
      document.addEventListener('zentein:cart:confirmed',()=>queueMicrotask(render));render();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>requestAnimationFrame(init),{once:true});else requestAnimationFrame(init);
  document.addEventListener('shopify:section:load',init);
})();

if(!customElements.get('ze-purchase-generic'))customElements.define('ze-purchase-generic',class extends HTMLElement{
  connectedCallback(){
    this.start=()=>requestAnimationFrame(()=>this.setup());
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',this.start,{once:true});else this.start();
  }
  disconnectedCallback(){this.events?.abort();this.observer?.disconnect();document.removeEventListener('DOMContentLoaded',this.start);}
  setup(){
    if(!this.isConnected||!document.body.classList.contains('ze-claude-pdp'))return;
    const form=this.closest('form'),info=this.closest('.product__info-container'),buttons=form?.querySelector('.product-form__buttons');
    if(!form||!info||!buttons)return;
    this.events?.abort();this.observer?.disconnect();this.events=new AbortController();
    const quantity=info.querySelector('.product-form__quantity');
    if(quantity&&!buttons.contains(quantity))buttons.prepend(quantity);
    buttons.classList.add('ze-generic-actions');info.classList.add('ze-generic-purchase');
    const productForm=this.closest('product-form');
    const placePlans=()=>{
      const widget=info.querySelector('.sealsubs-target-element');
      if(widget&&productForm&&!widget.contains(productForm)&&widget.nextElementSibling!==productForm)productForm.before(widget);
    };
    this.observer=new MutationObserver(placePlans);this.observer.observe(info,{subtree:true,childList:true});placePlans();
  }
});
